<template>
  <div class="row">
    <div class="col-md-12 d-flex justify-content-between">
      <h1 class="h3 mb-3 text-gray-800">
        {{ $t("Relatórios de Usuários") }}
      </h1>

      <b-dropdown
        no-caret
        variant="primary"
        size="sm"
        v-b-tooltip.hover
        right
        title="Menu de Relatórios de Usuários"
      >
        <template #button-content>
          Menu
          <i class="fas fa-bars"></i>
        </template>
        <b-dropdown-group id="dropdown-group-1" header="Relatórios de Famílias">
          <b-dropdown-item
            :to="'/dashboard/relatorios/usuarios/home'"
            :disabled="$route.name == 'relatorios_home_usuarios'"
          >
            Todos os Usuários
          </b-dropdown-item>
          <b-dropdown-item
            :to="'/dashboard/relatorios/usuarios/graficos'"
            :disabled="$route.name == 'graficos_usuarios'"
          >
            Gráficos de Usuários
          </b-dropdown-item>
        </b-dropdown-group>
      </b-dropdown>
    </div>

    <div class="col-md-12">
      <load v-if="loading" />
      <router-view v-else />
    </div>
  </div>
</template>
<script>
export default {
  name: "ReportsUsuarios",
  metaInfo() {
    return {
      title: this.$i18n.t("Relatórios de Usuários"),
    };
  },
  mounted() {},
  data() {
    return {
      loading: false,
    };
  },
  methods: {},
};
</script>
